import { createContext, useContext } from 'react';

/**
 * #552 — what ModalBackdrop tells the parts inside it.
 *
 * - `onClose`: the close action of the modal. ModalHeader puts it on the
 *   close X, so every modal has an X without a prop at each call site.
 * - `layout`: 'form' (the whole dialog scrolls, p-6) or 'panel' (a pinned
 *   header and footer, and ModalBody scrolls). ModalHeader, ModalBody and
 *   ModalFooter read it and take the classes of that layout.
 *
 * Outside a ModalBackdrop the value is null: the parts then use the 'form'
 * classes, and ModalHeader shows no X.
 */
export type ModalLayout = 'form' | 'panel';

export interface ModalContextValue {
  onClose: () => void;
  layout: ModalLayout;
}

export const ModalContext = createContext<ModalContextValue | null>(null);

export function useModalContext(): ModalContextValue | null {
  return useContext(ModalContext);
}
